import React, {useEffect, useCallback, useState} from 'react';
import {useDispatch} from 'react-redux';
import {useList} from 'react-use';
import classNames from 'classnames';
import {useParams} from 'react-router-dom';

import {getTopicTypes} from '../../../../actions/user-topic';
import TopicTypeItem from './TopicTypeItem'

import './TopicTypes.scss';
import TopicDragItem from "./TopicDragItem";

function TopicTypes() {
    const dispatch = useDispatch();
    const [topicTypes, topicTypesHelper] = useList([]);
    const [topicDetail, setTopicDetail] = useState(null);
    const {topicId} = useParams();

    useEffect(() => {
        fetchResource();
    }, []);

    const fetchResource = useCallback(async () => {
        const data = await dispatch(getTopicTypes(topicId));
        topicTypesHelper.set(data);
    }, []);

    const onDetail = useCallback((topic) => {
        setTopicDetail(topic);
    }, []);

    const onGoBack = useCallback(() => {
        setTopicDetail(null);
    }, []);

    return <div className="topic-data">
        <div className={classNames('front', topicDetail ? 'hide' : 'show')}>
            {topicTypes.map((topic, idx) => <TopicTypeItem
                id={topic.id}
                key={idx}
                list={topic.children}
                title={topic.name}
                onDetail={onDetail}
            />)}
        </div>
        <div className={classNames(topicDetail ? 'show' : 'hide')}>
            {topicDetail && <>
                <div style={{display: 'flex', alignItems: 'center', padding: 15}}>
                    <img src="/img/ic_arrow_left.svg" style={{cursor: 'pointer'}} onClick={onGoBack} alt=""/>
                    <div style={{marginLeft: 15, fontWeight: '500'}}>
                        {topicDetail.name}
                    </div>
                </div>
                <div style={{paddingLeft: 15, paddingRight: 15, paddingBottom: 15, fontSize: 16}}>
                    ドラッグ&ドロップで左の枠に追加します
                </div>
                <div className='block-form' style={{marginTop: 5}}>
                    {topicDetail.children.map((item, idx) => <TopicDragItem key={idx}
                                                                            id={item.topics_source_id}
                                                                            chart={item.chart}
                                                                            typeItem={item.type}
                                                                            parentId={topicDetail.id}
                                                                            name={item.name}/>)
                    }
                </div>
            </>}
        </div>
    </div>
}

export default TopicTypes;
